/* eslint-disable max-len */
import React, { Fragment } from 'react'
import TableBodyDevice from './TableBody'

const DeviceTable=({handleScroll,isLoading,items})=>{
    
    return(
        <div>
            <div id={"device_scrollarea"} onScroll={handleScroll} className='xl:h-[calc(100vh-385px)] h-[calc(100vh-410px)] overflow-auto scrollbar_purple pb-2.5'>
                <table aria-label="Outside Table" className="w-full table-auto">
                    <thead>
                        <tr className="h-[38px] w-full bg-[#EDD7E1] rounded-sm sticky top-[0px] left-0 z-[1]">
                            <th className="px-[18px] py-2 min-w-[100px] rounded-tl-sm rounded-bl-sm "  >
                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Device ID
                                </span>
                            </th>
                            <th className="px-[18px] py-2 min-w-[180px]">
                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Reading Type
                                </span>
                            </th>
                            <th  className="px-[18px] py-2 rounded-tr-[2px] rounded-br-[2px] bg-[#EDD7E1] min-w-[70px]">
                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Manufacturer
                                </span>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {items?.map((item,index)=>(
                            <Fragment key={item.index}>
                                <TableBodyDevice
                                    isLoading={isLoading}
                                    tableData={item}
                                />
                            </Fragment>
                        ))}
                        
        
                    </tbody>
                    
                </table>

            </div>
        </div>
    )
}

export default DeviceTable